













































































































































import Vue from 'vue';
import axios from 'axios';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import MStoreFilter from '@/components/shared/MStoreFilter.vue';
import { BTableHelpers, FormFieldValidation } from '@/mixins';

export default Vue.extend({
  name: 'MStorePickList',
  mixins: [BTableHelpers, FormFieldValidation],
  props: {
    headerName: {
      type: String,
      required: true
    },
    includedItemsApiPath: {
      type: String,
      required: true
    },
    allItemsApiPath: {
      type: String,
      required: true
    },
    picklistFields: {
      type: Array,
      required: true
    },
    fixedItems: {
      type: Array,
      required: false
    }
  },
  data() {
    return {
      includedItems: [] as object[],
      excludedItems: [] as object[],
      viewItemsFields: [] as object[],
      distinctFixedItems: [] as object[],
      headerFilters: {
        totalRows: 0 as number,
        searchQuery: '' as string
      } as object,
      showExcluded: false,
      showPicklist: false,
      isLoading: false,
      isPageLoading: true,
      hasError: false,
      isPicklistDirty: false,
      errorMessage: ''
    };
  },
  methods: {
    async getData(this: any) {
      this.isPageLoading = true;
      this.distinctFixedItems = Array.from(new Set(this.fixedItems));
      this.includedItems = await this.getItemsAsync(this.includedItemsApiPath);
      this.excludedItems = await this.getItemsAsync(this.allItemsApiPath);
      this.getExcludedItems();
      this.isPageLoading = false;
    },
    async getItemsAsync(this: any, apiPath: string) {
      return await axios
        .get(apiPath)
        .then((response) => {
          this.hasError = false;
          return response.data;
        })
        .catch((error: any) => {
          this.hasError = true;
          this.errorMessage = error.notification;
          return [];
        });
    },
    getExcludedItems(this: any) {
      this.excludedItems = this.excludedItems.filter(
        (excludedItem: any) =>
          this.includedItems.filter(
            (includedItem: any) =>
              excludedItem[Object.keys(excludedItem)[0]] === includedItem[Object.keys(includedItem)[0]]
          ).length === 0
      );
      this.viewItemsFields = this.picklistFields.map((x: any) => x);
      this.viewItemsFields.pop();
    },
    onFiltered(this: any, filteredItems: any) {
      this.headerFilters.totalRows = filteredItems.length;
    },
    removeItem(row: any) {
      const index = this.includedItems.findIndex((x: any) => x === row.item);
      this.includedItems.splice(index, 1);
      this.excludedItems.push(row.item);
      this.isPicklistDirty = true;
    },
    addItem(row: any) {
      const index = this.excludedItems.findIndex((x: any) => x === row.item);
      this.excludedItems.splice(index, 1);
      this.includedItems.push(row.item);
      this.isPicklistDirty = true;
    },
    canRemove(row: any): boolean {
      return !this.distinctFixedItems.find((x: any) => x === row.item.id);
    },
    save(this: any) {
      this.isLoading = true;
      this.$emit('saveClicked', this.includedItems);
      this.showPicklist = false;
      this.isLoading = false;
      this.isPicklistDirty = false;
    },
    cancel(this: any) {
      if (this.isPicklistDirty) {
        this.$bvModal
          .msgBoxConfirm('Are you sure you want to cancel, any changes will be lost?', {
            title: 'Are you sure?',
            cancelVariant: 'danger'
          })
          .then((result: boolean) => {
            if (result) {
              this.reset();
            }
          });
      } else {
        this.reset();
      }
    },
    reset() {
      this.showPicklist = false;
      if (this.isPicklistDirty) {
        this.isPicklistDirty = false;
        this.getData();
      }
    }
  },
  mounted(this: any) {
    this.getData();
  },
  computed: {
    disableControl(this: any) {
      return this.isPageLoading || this.isLoading || this.hasError;
    }
  },
  watch: {
    isPicklistDirty(this: any) {
      this.setApplicationDirty(this.isPicklistDirty);
    }
  },
  components: {
    LoadingSpinner,
    MStoreFilter
  }
});
